var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StepLayout } from '@/components/step-layout.component';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { Button, Typography } from '@mui/material';
import { useNavigator } from 'hx-navigator';
import { OverLayBanner } from '@/components/overlay-banner.component';
import { useSelector } from 'react-redux';
import { isResultsCategory } from '@/components/results-category/helpers/is-results-category.helper';
import { ErrorMessage } from '@/components/error-message.component';
import { NavigationButtonsContainer } from '@/components/navigation-button.component';
import { ResultsPageModalToggle } from '@/components/results-page-modal-toggle.component';
import { legatoImages } from '@/assets/images';
import { useStyledModal } from '@/components/modals/use-styled-modal.hook';
import { useEndSession } from '../hooks/use-end-session-click.hook';
import { useTestCompletionCallback } from '@/hooks/use-test-completion-callback.hook';
export default function ResultCategoryPage() {
    var _a = useState(''), image = _a[0], setImage = _a[1];
    var _b = useState(0), setStep = _b[1];
    var navigate = useNavigator().navigate;
    var location = useLocation();
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    var handleTestCompletion = useTestCompletionCallback();
    var handleEndSessionClick = useEndSession().handleEndSessionClick;
    var _c = useStyledModal({
        header: 'Disclaimer',
        content: (_jsx(Typography, __assign({ variant: "body-1" }, { children: "This screening is for informational purposes only and does not constitute medical advice. The information provided is not intended as a medical diagnosis nor as a diagnostic hearing evaluation. Consult a hearing care professional for a diagnosis or, if you are experiencing pain or discomfort, or if you have experienced a sudden change in hearing. This screener is intended for use only for ages 18 and above." }))),
    }), styledModal = _c.styledModal, toggleStyledModal = _c.toggleStyledModal;
    useEffect(function () {
        if (category && !location.pathname.includes(category)) {
            handleTestCompletion();
            // https://hearxgroup.atlassian.net/browse/DIGITS-1185
            navigate("/result-category/".concat(category));
        }
    }, [category, location.pathname]);
    if (!category || !isResultsCategory(category)) {
        return (_jsx(ErrorMessage, { action: function () { return navigate('/'); }, actionText: "Retake Test", message: "An error occurred while trying to display your result. Please try again." }));
    }
    return (_jsx(StepLayout, { progress: { phase: 2, step: 4 }, overlayedContent: _jsx(OverLayBanner, { content: _jsx(ResultsPageModalToggle, { className: "text-base font-extrabold leading-none text-black underline decoration-black", toggleModal: toggleStyledModal, text: "Disclaimer" }), className: "bg-banner-brown text-center text-xl font-bold text-white py-2.5" }), image: image, content: _jsxs(_Fragment, { children: [_jsx(Outlet, { context: {
                        setImage: setImage,
                        setStep: setStep,
                    } }), styledModal] }), nav: _jsxs("div", __assign({ className: 'flex flex-col items-center justify-center py-2' }, { children: [_jsx(ResultsPageModalToggle, { className: "text-base text-black underline decoration-black md:pb-5", toggleModal: toggleStyledModal, text: "Disclaimer" }), _jsx(NavigationButtonsContainer, __assign({ className: "mb-3" }, { children: _jsx(Button, __assign({ variant: "contained", onClick: handleEndSessionClick, className: 'sm:w-60 sm:max-w-60 py-3 w-full disabled:bg-primary/40 text-center' }, { children: "End Session" })) }))] })), footer: _jsx("div", __assign({ className: 'grid w-full place-items-center pb-4' }, { children: _jsx("img", { src: legatoImages.legatoLogoMaroon, alt: "Legato logo", className: "w-24" }) })) }));
}
export function ResultCategoryOutlet() {
    return _jsx(Outlet, { context: useResultCategoryOutletContext() });
}
